import produce from "immer";

import {
  QUIZ1_DATA_WATCH,
  QUIZ1_DATA_UPDATE,
  QUIZ1_META_FETCH,
  QUIZ1_META_WATCH
} from "../actions/types";

const initialState = {
  data: null,
  meta: null
};

export default (state = initialState, action) => {
  return produce(state, draft => {
    // eslint-disable-next-line
    switch (action.type) {
      case QUIZ1_DATA_WATCH:
        draft.data = action.payload.data;
        break;
      case QUIZ1_META_WATCH:
        console.log(action.payload);
        draft.meta = action.payload.meta;
        break;
      case QUIZ1_DATA_UPDATE:
        console.log("no reducer update");
        break;
    }
  });
};
